export class ActiveEicCodesReportTableHeaders {
    allColumns = [
        { field: 'lioNumber', header: 'LIO Number', visible: true, activeStatus: true, sort: true, filter: false, minWidth: 160, isDate: false},
        { field: 'name', header: 'LIO Name', visible: true, activeStatus: true, sort: false, filter: false, minWidth: 150, isDate: false},
        { field: 'activeEic', header: 'Active Codes', visible: true, activeStatus: true, sort: false, filter: false, minWidth: 150, isDate: false },
        { field: 'inactiveEic', header: 'Inactive Codes', visible: true, activeStatus: true, sort: false, filter: false , minWidth: 150, isDate: false},
        { field: 'totalEic', header: 'Total Codes', visible: true, activeStatus: true, sort: false, filter: false, minWidth: 150, isDate: false },
    ];
}
  